import React from 'react'
import Navbar from '../components/Navbar'
import ContactForm from '../components/ContactForm'
import ContactInfo from '../components/ContactInfo'
import Footer from '../components/Footer'
import { Helmet } from "react-helmet-async";

const ContactPage = () => {
  return (
    <>
      {/* ✅ SEO + Tab Title */}
      <Helmet>
        <title>Contact Us | VisionBird Technologies</title>
        <meta
          name="description"
          content="Get in touch with VisionBird Technologies for web development, design, and digital solutions. Contact us for projects, support, or inquiries."
        />
      </Helmet>

      <Navbar />
      <ContactForm />
      <ContactInfo />
      <Footer />
    </>
  )
}

export default ContactPage